import api from "./axios";

export const getAuditLogs = ({ action, resourceType, limit = 50, offset = 0 } = {}) =>
  api.get("/audit-logs", {
    params: {
      action: action || undefined,
      resource_type: resourceType || undefined,
      limit,
      offset,
    },
  });
